import { buildApiUrl, withBusinessHeaders } from './apiConfig';

const MASTER_SETTINGS_API_URL =
  process.env.REACT_APP_MASTER_SETTINGS_API_URL || buildApiUrl('/master-settings');

export async function fetchTareAmountFeeSetting() {
  const response = await requestMasterSettingApi(
    `${MASTER_SETTINGS_API_URL}/tare-amount-fee`,
    {
      fallbackMessage: 'Unable to load tare amount fee right now.',
    }
  );

  return response.json();
}

export async function updateTareAmountFeeSetting(payload) {
  const response = await requestMasterSettingApi(
    `${MASTER_SETTINGS_API_URL}/tare-amount-fee`,
    {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
      fallbackMessage: 'Unable to save tare amount fee right now.',
    }
  );

  return response.json();
}

export async function fetchTareAmountFeeHistoryLogs() {
  const response = await requestMasterSettingApi(
    `${MASTER_SETTINGS_API_URL}/tare-amount-fee/history`,
    {
      fallbackMessage: 'Unable to load tare fee history right now.',
    }
  );

  return response.json();
}

export async function fetchSavingsPerKiloSetting() {
  const response = await requestMasterSettingApi(
    `${MASTER_SETTINGS_API_URL}/savings-per-kilo`,
    {
      fallbackMessage: 'Unable to load savings per kilo right now.',
    }
  );

  return response.json();
}

export async function updateSavingsPerKiloSetting(payload) {
  const response = await requestMasterSettingApi(
    `${MASTER_SETTINGS_API_URL}/savings-per-kilo`,
    {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
      fallbackMessage: 'Unable to save savings per kilo right now.',
    }
  );

  return response.json();
}

export async function fetchSavingsPerKiloHistoryLogs() {
  const response = await requestMasterSettingApi(
    `${MASTER_SETTINGS_API_URL}/savings-per-kilo/history`,
    {
      fallbackMessage: 'Unable to load savings per kilo history right now.',
    }
  );

  return response.json();
}

async function requestMasterSettingApi(url, options) {
  const { fallbackMessage, ...requestOptions } = options;
  let response;

  try {
    response = await fetch(url, {
      ...requestOptions,
      headers: withBusinessHeaders(requestOptions.headers),
    });
  } catch (error) {
    throw new Error(getNetworkErrorMessage(error, fallbackMessage));
  }

  if (!response.ok) {
    const errorPayload = await safeReadJson(response);
    throw new Error(errorPayload?.message || fallbackMessage);
  }

  return response;
}

function getNetworkErrorMessage(error, fallbackMessage) {
  if (typeof navigator !== 'undefined' && navigator.onLine === false) {
    return 'You are offline right now. Please reconnect to continue.';
  }

  if (error instanceof TypeError) {
    return 'Unable to reach the server right now. Please check your connection or try again in a moment.';
  }

  return fallbackMessage;
}

async function safeReadJson(response) {
  try {
    return await response.json();
  } catch (error) {
    return null;
  }
}
